<template>
    <v-card
      v-if='this.reservation'
      class='mx-auto ma-6'
      width='100%'
      max-width='500'
      flat
      outlined
      hover
    >
        <v-img
          class='white--text'
          height='200px'
          :src='apartment_image'
          alt='apartment image'
        >
          <v-card-title class='align-end fill-height'/>
        </v-img>

        <v-card-text class='text--secondary'>
          <span v-html='i18nReservationCode'/>
          <br>
          <span v-html='this.$t("reservation.attributes.stay_period", { from: this.formattedDate(this.order.checkin_date), to: this.formattedDate(this.order.checkout_date) })'/>
          <br>
          <span>{{ $t('reservation.attributes.apartment') }}: <strong>{{ apartment_name }}</strong></span><br>
          <span>{{ $t('reservation.attributes.guest_checkin_state') }}: <strong>{{ i18nCheckinState }}</strong></span><br>
          <span>
            {{ $t('reservation.attributes.guests') }}:
            <strong v-bind:class="{ 'guests--incomplete': reservation.guests.length != reservation.booked_guests}">
              {{ reservation.guests.length }} / {{ reservation.booked_guests }}
            </strong>
          </span>
          <v-icon v-if="checkinCompleted" color='success'>mdi-check-bold</v-icon>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <router-link v-if = "reservation.guest_checkin_state != fastcheckin_completed && reservation.status != checkin_closed"
            :to='{
              name: "checkinGuests",
              params: {
                uuid: this.order.uuid,
                reservation_id: this.reservation.id
              }
            }'
            style="min-width: 100px; max-width: 100%;"
            class="flex-grow-1 flex-shrink-0 no-underline"  >
            <v-btn block color='primary' >
              {{ $t('order.checkin.show') }}
            </v-btn>
          </router-link>
          <router-link
            :to='{
              name: "ReservationDetails",
              params: { id: this.reservation.id }
            }'
          >
            <v-btn icon x-large><v-icon>mdi-arrow-right-bold-box-outline</v-icon></v-btn>
          </router-link>

        </v-card-actions>

    </v-card>
</template>

<script>
  import { utilityMixin } from '../../mixins/utility_mixin'
  import { reservationMixin } from '../../mixins/reservation_mixin'
  import { apartmentMixin } from '../../mixins/apartment_mixin'

  export default {
    name: 'ReservationCardLite',
    mixins: [
      utilityMixin,
      reservationMixin,
      apartmentMixin
    ],
    props: {
      order: {
        type: Object,
        required: true
      },
      reservation: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        checkin_closed: 'CHECKIN_CLOSED',
        fastcheckin_completed: 'completed'
      }
    },
    computed: {
      status() {
        return this.reservation ? this.reservation.status : ''
      }
    }
  }
</script>

<style lang='scss' scoped>
  .no-underline {
    text-decoration: none;
  }

  .v-card__title {
    text-shadow: 2px 2px #666;
  }

  .guests--incomplete {
    color: red;
  }
</style>
